import styled from 'styled-components';

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 20px;

`;

export const FooterButton = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
`;

export const FormContainer = styled.form`
  display: flex;
  flex-flow: column;
  gap: 16px;
  padding: 20px 0;

  .BaSe--grid {
    margin: 0;
  }
`;

export const Ativo = styled.div`
  margin-top: 30px;
  text-align: end;
`;

export const CheckAtivoContainer = styled.div`
  height: 84%;
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
`;
